import { Button, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import SubCard from 'ui-component/cards/SubCard';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';
import { useEffect } from 'react';
import { MapCspToFos, UnMapCspFromFos } from 'API/fos_mapping/api';
import ConfirmDialog from './ConfirmationDialog';
import ConfirmUnMapDialog from './UnMapDialog';

const TableComponent = (props) => {
  const [SelectedCsps, setSelectedCsps] = useState([]);
  const [SelectAll, setSelectAll] = useState(false);

  const [OpenConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [OpenUnmapConfirmDialog, setOpenUnmapConfirmDialog] = useState(false);
  const [UnMapUserId, setUnMapUserId] = useState(null);

  const handleConfirmDialogOpen = () => {
    if (Array.isArray(SelectedCsps) && SelectedCsps.length === 0) {
      props.handleAlertOpen('Please select at least one CSP to map', 'error');
      return;
    }
    setOpenConfirmDialog(true);
  };

  const handleConfirmDialogClose = () => {
    setOpenConfirmDialog(false);
  };

  const handleUnmapConfirmDialogOpen = (id) => {
    setOpenUnmapConfirmDialog(true);
    setUnMapUserId(id);
  };

  const handleUnmapConfirmDialogClose = () => {
    setOpenUnmapConfirmDialog(false);
    setUnMapUserId(null);
  };

  const handleCheckboxChange = (event, cspId) => {
    if (event.target.checked) {
      setSelectedCsps((prevSelected) => [...prevSelected, cspId]);
    } else {
      setSelectedCsps((prevSelected) => prevSelected.filter((id) => id !== cspId));
    }
  };

  const handleCheckboxSelectAll = (event) => {
    if (event.target.checked) {
      // Select all checkboxes
      const allCspIds = props.data && props.data.data && Array.isArray(props.data.data) ? props.data.data.map((row) => row._id) : [];
      setSelectedCsps((prevSelect) => [...prevSelect, ...allCspIds]);
      setSelectAll(true);
    } else {
      // Deselect all checkboxes
      setSelectedCsps([]);
      setSelectAll(false);
    }
  };

  useEffect(() => {
    if (SelectAll) {
      setSelectAll(false);
    }
  }, [props.data]);

  const handleMapCsp = () => {
    if (SelectedCsps.length === 0) {
      props.handleAlertOpen('Please select at least one CSP to map', 'error');
      return;
    }
    handleConfirmDialogClose();
    MapCspToFos(props.fos, SelectedCsps, props.setIsLoading, props.handleAlertOpen, props.handleGet, setSelectedCsps, setSelectAll);
  };

  const handleUnmapCsp = () => {
    if (!UnMapUserId) {
      props.handleAlertOpen('No CSP selected for unmapping', 'error');
      return;
    }

    UnMapCspFromFos(props.fos, UnMapUserId, props.setIsLoading, props.handleAlertOpen, props.handleGet);
    handleUnmapConfirmDialogClose();
  };

  console.log('Selected Csps:', SelectedCsps, props);

  return (
    <Grid container mt={2}>
      <ConfirmUnMapDialog open={OpenUnmapConfirmDialog} handleClose={handleUnmapConfirmDialogClose} handleSubmit={() => handleUnmapCsp()} />
      <ConfirmDialog open={OpenConfirmDialog} handleClose={handleConfirmDialogClose} handleSubmit={handleMapCsp} />
      <Grid item xs={12}>
        <SubCard>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ color: '#20415C', marginBottom: 1 }} fontWeight={600}>
                FOS Mapping
              </Typography>
            </Grid>
            <Grid item lg={1} md={2} xs={4} sx={{ display: props.agent_type && props.agent_type === 'unmapped' ? 'block' : 'none' }}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="small"
                disabled={props.fos ? false : true}
                sx={{
                  backgroundColor: '#688B2A',
                  color: '#FFFFFF',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#688B2A'
                  }
                }}
                onClick={() => handleConfirmDialogOpen()}
              >
                Map Csp
              </Button>
            </Grid>

            <Grid item lg={2} md={2} xs={4} sx={{ display: props.agent_type && props.agent_type === 'mapped' ? 'block' : 'none' }}>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#20415C', textAlign: 'left' }}>
                Csp List
              </Typography>
            </Grid>

            <Grid item lg={2} md={2} xs={4}>
              <FormControl fullWidth size="small">
                {/* <InputLabel id="demo-simple-select-label">Fos</InputLabel> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={props.agent_type ? props.agent_type : ''}
                  // onChange={(e) => props.handleChange("fos", e.target.value === 'select' ? null : e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%', // change border color
                      borderRadius: '8px' // change border radius
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%' // change border color
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%' // change border color
                    }
                  }}
                  onChange={(e) => props.handleChange('csp_type', e.target.value === 'select' ? null : e.target.value)}
                >
                  {/* <MenuItem value="select">Select FOS</MenuItem> */}
                  <MenuItem value={'unmapped'}>Unmapped CSP</MenuItem>
                  <MenuItem disabled={!props.fos || props.fos === '' || props.fos === 'select'} value={'mapped'}>
                    Mapped CSP
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container mt={2} justifyContent="center">
            <Grid item xs={12}>
              {/* Placeholder for the table component */}
              <div style={{ height: '100%', width: '100%' }}>
                {/* Table content goes here */}
                {props.agent_type && props.agent_type === 'mapped' ? (
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#F8FAFC' }}>
                          <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                            CSP Name
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, color: '#592375' }}>
                            CSP Code
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, color: '#592375' }}>
                            Bank Name
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, color: '#592375' }}>
                            Date of Activation
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, color: '#592375' }}>
                            Mapped FOS
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, color: '#592375' }}>
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {!props.data || (props.data && props.data.data && Array.isArray(props.data.data) && props.data.data.length === 0) ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={5}>
                              <Stack alignItems="center" justifyContent="center" width="100%">
                                <Typography variant="h5" sx={{ color: '#20415C', marginTop: 2, textAlign: 'center' }}>
                                  No Mapped CSP Found
                                </Typography>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody>
                          {props.data &&
                            props.data.data &&
                            Array.isArray(props.data.data) &&
                            props.data.data.map((row, index) => (
                              <TableRow
                                key={row._id}
                                sx={{
                                  '&:last-child td, &:last-child th': { border: 0 },
                                  backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff'
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {row.first_name}
                                </TableCell>
                                <TableCell align="center">{row.csp_code ? row.csp_code : '-'}</TableCell>
                                <TableCell align="center">
                                  {row.product_info && row.product_info.product_display_name ? row.product_info.product_display_name : '-'}
                                </TableCell>
                                <TableCell align="center">
                                  {row.product_info && row.product_info.csp_code_activation_date
                                    ? row.product_info.csp_code_activation_date.split('-').reverse().join('-')
                                    : '-'}
                                </TableCell>
                                <TableCell align="center">{props.fosName}</TableCell>
                                <TableCell align="center">
                                  <Button
                                    variant="contained"
                                    color="warning"
                                    size="small"
                                    sx={{ borderRadius: '8px' }}
                                    onClick={() => handleUnmapConfirmDialogOpen(row._id)}
                                  >
                                    Unmap
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                ) : (
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#F8FAFC' }}>
                          <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                            <Checkbox checked={SelectAll} onChange={handleCheckboxSelectAll} size="small" />
                          </TableCell>
                          <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                            CSP Name
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, color: '#592375' }}>
                            CSP Code
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, color: '#592375' }}>
                            Bank Name
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, color: '#592375' }}>
                            Date of Activation
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.data &&
                          props.data.data &&
                          Array.isArray(props.data.data) &&
                          props.data.data.map((row, index) => (
                            <TableRow
                              key={row._id}
                              sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                                backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff'
                              }}
                            >
                              <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                                <Checkbox
                                  checked={SelectedCsps.findIndex((item) => item === row._id) > -1 ? true : false}
                                  onChange={(e) => handleCheckboxChange(e, row._id)}
                                  size="small"
                                />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {row.first_name}
                              </TableCell>
                              <TableCell align="center">{row.csp_code ? row.csp_code : '-'}</TableCell>
                              <TableCell align="center">
                                {row.product_info && row.product_info.product_display_name ? row.product_info.product_display_name : '-'}
                              </TableCell>
                              <TableCell align="center">
                                {row.product_info && row.product_info.csp_code_activation_date
                                  ? row.product_info.csp_code_activation_date.split('-').reverse().join('-')
                                  : '-'}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                <TablePagination
                  component="div"
                  count={props.data?.total ?? 0} // Total number of items (not pages)
                  page={props.data?.page ? props.data.page - 1 : 0} // Material-UI pagination is zero-based
                  onPageChange={props.handlePageChange}
                  rowsPerPage={20} // Required when rowsPerPageOptions is used
                  rowsPerPageOptions={[20]} // Fixed page size of 20
                />
              </div>
            </Grid>
          </Grid>
        </SubCard>
      </Grid>
    </Grid>
  );
};

export default TableComponent;
